import { useContext } from "react";
import { SendToAccountingActionContext } from "./SendToAccountingActionContext";

function usePrepareSendToAccounting() {
  const { setShowModal } = useContext(SendToAccountingActionContext);

  return () => {
    setShowModal(true);
  };
}

export default usePrepareSendToAccounting;
